import { render } from "./DarkLightModeSwitch.vue?vue&type=template&id=5542b034"
import script from "./DarkLightModeSwitch.vue?vue&type=script&lang=js"
export * from "./DarkLightModeSwitch.vue?vue&type=script&lang=js"

import "./DarkLightModeSwitch.vue?vue&type=style&index=0&id=5542b034&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__